import { Fragment } from "react";
import AdSection from "../../../../Components/AdSection/AdSection";
import { AD_SLOTS } from "../../../../config/adSlots";
import { getWomanThumbImageUrl } from "../../../../utils/imageUrl";
import WomanCard from "../WomanCard/WomanCard";

const DESKTOP_AD_INTERVAL = 8;
const MOBILE_AD_INTERVAL = 4;

function shouldShowAdAfter(index, interval) {
    return (index + 1) % interval === 0;
}

function WomenResultsGrid({ women, isFiltered, noResultsText }) {
    if (women.length === 0) {
        return isFiltered ? <p className="no-results">{noResultsText}</p> : null;
    }

    return women.map((woman, index) => (
        <Fragment key={woman.id}>
            <WomanCard
                id={woman.id}
                name={woman.name}
                surname={woman.surname}
                domain={woman.category_name}
                categoryColor={woman.category_color}
                image={getWomanThumbImageUrl(woman.image)}
            />
            {shouldShowAdAfter(index, DESKTOP_AD_INTERVAL) && (
                <AdSection
                    adSlot={AD_SLOTS.homeWomenInline}
                    adFormat="horizontal"
                    className="home-results__ad home-results__ad--desktop"
                />
            )}
            {shouldShowAdAfter(index, MOBILE_AD_INTERVAL) && (
                <AdSection
                    adSlot={AD_SLOTS.homeWomenInline}
                    adFormat="rectangle"
                    className="home-results__ad home-results__ad--mobile"
                />
            )}
        </Fragment>
    ));
}

export default WomenResultsGrid;
